<template>
  <div class="sd-input">
    <input v-if="!area" :type="type" :value="value" :placeholder="localPlaceholder" @input="handleInput" />
    <textarea v-else rows="5" :placeholder="localPlaceholder" @input="handleInput" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

// TODO: refactor this component and use in all places, currently styles applies from this file
// update to scoped after it.
@Component
export default class Input extends Vue {
  @Prop({ default: '' }) value!: string;
  @Prop({ default: '' }) placeholder!: string;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: 'text' }) type!: 'text' | 'number';
  @Prop({ default: false }) area!: boolean;

  get localPlaceholder() {
    const { placeholder, required } = this;
    if (placeholder && required) {
      return `* ${placeholder}`;
    }
    return placeholder;
  }

  handleInput(v: string) {
    this.$emit('input', v);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variable.scss';

.sd-input {
  input,
  textarea {
    width: 100%;
    font-size: $size-m2;
    padding: 9px;
    border-radius: 4px;
    border: $input-box-border;
    outline: none;
    transition: border-color 0.2s ease;
    background-color: $input-box-background;
    color: $input-box-text-color;
    &::placeholder {
      color: $input-box-placeholder-color;
      font-size: $size-m2;
    }
    &:focus {
      border-color: $input-box-focus-outline;
    }
    &.warn {
      border-color: $input-box-focus-outline-error;
    }
    &:disabled {
      background: $input-box-background--disabled;
    }
  }

  .warn-note-wrapper {
    color: $input-box-asterisk-color;
    font-size: 12px;
    margin-bottom: 10px;
    .star {
      color: $input-box-asterisk-color;
    }
  }

  textarea {
    resize: none;
    overflow-y: scroll;
  }

  .textarea-char {
    font-size: 12px;
    padding-bottom: 4px;
    text-align: right;

    &.exceed {
      color: $input-form-error-message-text-color;
    }
  }
}
</style>
